import { EXCEPTION_CODES, EXCEPTION_FIELD_CODES } from '../../api/exceptions/codes';

const MESSAGES: Record<EXCEPTION_CODES, string> = {
  [EXCEPTION_CODES.FORMAT_ERROR]: 'Format error',
  [EXCEPTION_CODES.NOT_AUTHENTICATED]: 'User not authenticated',
  [EXCEPTION_CODES.ENTITY_NOT_FOUND]: 'Not found',
  [EXCEPTION_CODES.ENTITY_NOT_UNIQUE]: 'Not unique',
  [EXCEPTION_CODES.SERVER_ERROR]: 'Server error. Please contact system administrator.',
  [EXCEPTION_CODES.CODE_VERIFICATION_FAILED]: 'Code verification failed',
  [EXCEPTION_CODES.TOO_MANY_REQUESTS]: 'Too many requests. You are blocked. Try again later',
  [EXCEPTION_CODES.MAX_CHECK_ATTEMPTS_REACHED]:
    'Max check attempts reached. You are blocked for 10 min',
  [EXCEPTION_CODES.TWILIO_MAX_SEND_ATTEMPTS_REACHED]:
    'Twillio has temporarily blocked your phone number. Please try again later',
  [EXCEPTION_CODES.TWILIO_TEMPORARELY_BLOCKED]:
    'Twillio has temporarily blocked your phone number. Please try again later',
  [EXCEPTION_CODES.TWILIO_INVALID_PHONE_NUMBER]: 'Invalid phone number',
  [EXCEPTION_CODES.CODE_INVALID]: 'Invalid code',
  [EXCEPTION_CODES.ERR_NETWORK]:
    'Please ensure your device is connected to the internet and try again',
  [EXCEPTION_CODES.USER_NOT_FOUND]: 'Account does not exist. Please, register by the link below',
  [EXCEPTION_CODES.VALIDATION_EXCEPTION]: 'Validation error',
  [EXCEPTION_CODES.USER_NOT_UNIQUE]: 'User not unique',
  [EXCEPTION_CODES.PLAID_LINK_TOKEN_ERROR]: 'Plaid link token error',
  [EXCEPTION_CODES.SURVEY_NOT_FOUND]: 'Survey not found',
  [EXCEPTION_CODES.SURVEY_NOT_UNIQUE]: 'Survey not unique',
  [EXCEPTION_CODES.REWARD_NOT_UNIQUE]: 'Reward not unique',
  [EXCEPTION_CODES.PLAID_TOKEN_EXCHANGE_ERROR]: 'Plaid token exchange error',
  [EXCEPTION_CODES.SURVEYANSWER_NOT_UNIQUE]: 'Survey already filled. Continue in the app.',
  [EXCEPTION_CODES.COLLECTIONSHARE_NOT_FOUND]: 'Collection share not found',
};

const FIELD_MESSAGES: Record<EXCEPTION_FIELD_CODES, string> = {
  [EXCEPTION_FIELD_CODES['string.empty']]: 'Can not be empty',
  [EXCEPTION_FIELD_CODES['string.phone.format']]: 'Invalid phone number',
  [EXCEPTION_FIELD_CODES['string.phone.country']]:
    'Sorry, but the app is currently available in the US only',
};

export type FieldsType = Array<{
  path: Array<string>;
  type: EXCEPTION_FIELD_CODES;
}>;

export const getErrorMessage = (code?: EXCEPTION_CODES): string => {
  return (code && MESSAGES[code]) || MESSAGES[EXCEPTION_CODES.SERVER_ERROR];
};

export const getFieldErrorMessages = (fields?: FieldsType) => {
  if (!fields) return;

  const fieldMessages: Record<string, string> = {};

  fields.forEach((field) => {
    const key = field.path[field.path.length - 1];

    fieldMessages[key] = FIELD_MESSAGES[field.type];
  });

  return fieldMessages;
};
